import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../../store/ui/ui-slice";

const ProtectedRoute = () => {
  const token = useSelector((state) => state.user?.token);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!token) return;

    dispatch(uiActions.setLoading(false));
    dispatch(uiActions.setFormSubmitLoading(false));
  }, [dispatch, token]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
